import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function RepositoryUploadIcon({
  className,
  height,
  stroke = IconColors.Primary,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 131}
      viewBoxDimensions="0 0 131 130"
      width={width ?? 131}
    >
      <g opacity="0.6">
        <path
          d="M65.4999 70.4583V114.125M65.4999 70.4583L43.6665 92.2916M65.4999 70.4583L87.3332 92.2916M21.8332 80.8237C17.7779 76.6804 14.7186 71.6685 12.8872 66.1677C11.0557 60.6669 10.5001 54.8215 11.2624 49.0742C12.0246 43.3269 14.0848 37.8284 17.2869 32.9952C20.489 28.1621 24.7489 24.121 29.7441 21.178C34.7393 18.2351 40.3387 16.4675 46.1182 16.0091C51.8977 15.5508 57.7057 16.4136 63.1024 18.5324C68.499 20.6512 73.3427 23.9703 77.2666 28.2383C81.1904 32.5063 84.0916 37.6113 85.7503 43.1666H95.5207C100.791 43.166 105.921 44.8605 110.154 47.9997C114.388 51.1389 117.499 55.5563 119.028 60.5995C120.558 65.6427 120.425 71.0442 118.649 76.006C116.874 80.9679 113.549 85.227 109.167 88.1542"
          fill="none"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity="0.4"
          strokeWidth="8"
        />
      </g>
    </SimpleIcon>
  );
}
